"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = require("debug");
var React = require("react");
var trigger_button_1 = require("./util/trigger-button");
exports.createTriggerButton = trigger_button_1.default;
var d = debug_1.default('draft-js-plugin-editor-toolbar-picker');
function createPicker(options) {
    options = __assign({ triggerItem: trigger_button_1.default({ child: 'Button' }), items: [], autoClose: true, closeButton: trigger_button_1.default({ child: React.createElement(CloseIcon, null) }) }, options);
    var Picker = /** @class */ (function (_super) {
        __extends(Picker, _super);
        function Picker() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleClose = function () {
                _this.props.onOverrideContent(undefined);
                d('Hide sub menu');
            };
            return _this;
        }
        Picker.prototype.componentDidMount = function () {
            var _this = this;
            setTimeout(function () { window.addEventListener('click', _this.handleClose); });
        };
        Picker.prototype.componentWillUnmount = function () {
            window.removeEventListener('click', this.handleClose);
        };
        Picker.prototype.render = function () {
            var _this = this;
            var CloseButton = options.closeButton;
            return (React.createElement("div", null,
                React.createElement("span", { onClick: function (e) { return e.stopPropagation(); } }, options.items.map(function (Button, index) { return (React.createElement(Button, __assign({ key: index, onPickerClose: _this.handleClose }, _this.props))); })),
                options.autoClose
                    ? null
                    : React.createElement("span", null,
                        React.createElement("i", null, "\u00A0\u00A0\u00A0\u00A0\u00A0"),
                        React.createElement(CloseButton, { onClick: this.handleClose, theme: this.props.theme }))));
        };
        return Picker;
    }(React.Component));
    return function (_a) {
        var onOverrideContent = _a.onOverrideContent, theme = _a.theme;
        var Trigger = options.triggerItem;
        return (React.createElement(Trigger, { onClick: function () {
                onOverrideContent(Picker);
                d('Show sub menu');
            }, theme: theme, onOverrideContent: onOverrideContent }));
    };
}
exports.default = createPicker;
function CloseIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "-2 -2 20 20" },
        React.createElement("path", { d: "M8.5,1C4.358,1,1,4.358,1,8.5C1,12.643,4.358,16,8.5,16c4.143,0,7.5-3.357,7.5-7.5C16,4.358,12.643,1,8.5,1z M11.975,5.732 L9.188,8.52l2.467,2.748c0.195,0.195,0.195,0.512,0,0.707s-0.512,0.195-0.707,0L8.481,9.227l-2.749,2.748 c-0.195,0.195-0.512,0.195-0.707,0c-0.195-0.195-0.195-0.512,0-0.707l2.787-2.787L5.346,5.732c-0.195-0.195-0.195-0.512,0-0.707 c0.195-0.195,0.512-0.195,0.707,0L8.52,7.774l2.748-2.749c0.195-0.195,0.512-0.195,0.707,0C12.17,5.22,12.17,5.537,11.975,5.732z" })));
}
